import axios from 'axios'
import fg_lightning from 'fg_lightning'
import { getQueryString, encrypt  } from '@/utils/tools'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 20000,
})

instance.interceptors.request.use((config) => {
  const orgid = getQueryString('orgid')
  // 闪电云机构header定制
  if (
    orgid === '539' ||
    orgid === '29'
  ) {
    try {
      const user = fg_lightning.call('user')
      if (user) {
        const data = encrypt(
          JSON.stringify({
            id: user.id,
            orgid: user.orgid,
            nickname: user.nickname,
          })
        )

        config.headers.sdy = data
      }
    } catch (error) {
    }
    // 在网页里的情况
    if (getQueryString('sdyOrgId')) {
      const data = encrypt(
        JSON.stringify({
          id: getQueryString('sdyUserId'),
          orgid: getQueryString('sdyOrgId'),
          username: decodeURI(getQueryString('sdyUserName')),
        })
      )

      config.headers.sdy = data
    }
  }

  // config.headers['CQ-MEMBER-TOKEN'] = localStorage.getItem('token')

  return config
})

export const get = (url, params = {}, config = {}) => {
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params,
        ...config,
      })
      .then(
        (response) => {
          resolve(response.data)
        },
        (err) => {
          reject(err)
        }
      )
  })
}

export const post = (url, data = {}, config = {}) => {
  // let instanceToUse = defaultInstance;  
  // console.log('config.baseURL', config.baseURL)
  // if (config.baseURL) {  
  //   instanceToUse = axios.create({  
  //     baseURL: config.baseURL,  
  //     timeout: 20000,  
  //   });
  // }

  return new Promise((resolve, reject) => {
    instance
      .post(url, data, {
        ...config
      })
      .then(
        (response) => {
          resolve(response.data)
        },
        (err) => {
          reject(err)
        }
      )
  })
}

export const patch = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    instance
      .patch(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
